import { useWebSocket } from './lib/use-websocket';
export default useWebSocket;
export { useSocketIO } from './lib/use-socket-io';
export { ReadyState } from './lib/constants';
export { useEventSource } from './lib/use-event-source';
export { resetGlobalState } from './lib/util';
//# sourceMappingURL=index.js.map